import {
  Box,
  VStack,
  HStack,
  Text,
  IconButton,
  Slider,
  Accordion,
  Badge,
  Flex,
  Separator,
} from "@chakra-ui/react";
import { MdGraphicEq } from "react-icons/md";
import { FiArrowRight, FiArrowLeft, FiRotateCw, FiX } from "react-icons/fi";
import { motion } from "framer-motion";
import { useState } from "react";
import Categories from "./Categories";
import ColorRadios from "./ColorRadios";
import SizeSelect from "./Sizes";
import SelectC from "../../theme/SelectC";
import Tooltip from "../../theme/Tooltip";

const MotionBox = motion(Box);

export default function SideFilters({
  filters,
  backendFilters,
  handleFilterChange,
  clear,
  refresh,
  filtersStatus,
  activeFlags = {},
}) {
  const colorsData = backendFilters?.colors || [];
  const sizesData = backendFilters?.sizes || [];

  const sortOptions = [
    { label: "Featured", value: "featured" },
    { label: "Price: Low to High", value: "price_low" },
    { label: "Price: High to Low", value: "price_high" },
    { label: "Newest", value: 
      "newest" },
  ];

  const [sortBy, setSortBy] = useState();
  console.log(sortBy);
  const sectionTitle = (label, active) => (
    <Flex w="full" align="center" justify="space-between">
      <Text fontWeight="semibold">{label}</Text>
      {active && (
        <Badge
          px={2}
          py={0.5}
          rounded="full"
          fontSize="0.65rem"
          bg="black"
          color="white"
        >
          Active
        </Badge>
      )}
      <Accordion.ItemIndicator />
    </Flex>
  );

  const contentAnim = {
    initial: { opacity: 0, y: -6 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.18 },
  };

  return (
    <Box
      bg="white"
      borderWidth="1px"
      borderColor="gray.200"
      rounded="lg"
      boxShadow="md"
      p={4}
    >
      <Accordion.Root multiple defaultValue={["categories", "color", "size"]}>
        {/* Categories */}
        <Accordion.Item value="categories">
          <Accordion.ItemTrigger>
            {sectionTitle("Categories", activeFlags.categories)}
          </Accordion.ItemTrigger>
          <Accordion.ItemContent>
            <Accordion.ItemBody>
              <MotionBox {...contentAnim}>
                <Categories
                  filters={filters}
                  handleFilterChange={handleFilterChange}
                  backendFilters={backendFilters}
                  filtersStatus={filtersStatus}
                />
              </MotionBox>
            </Accordion.ItemBody>
          </Accordion.ItemContent>
        </Accordion.Item>

        {/* Color */}
        <Accordion.Item value="color">
          <Accordion.ItemTrigger>
            {sectionTitle("Color", activeFlags.colors)}
          </Accordion.ItemTrigger>
          <Accordion.ItemContent>
            <Accordion.ItemBody>
              <MotionBox {...contentAnim}>
                <ColorRadios
                  selectedValue={filters.colors}
                  colorItems={colorsData}
                  onChange={(color) => handleFilterChange("colors", color)}
                />
              </MotionBox>
            </Accordion.ItemBody>
          </Accordion.ItemContent>
        </Accordion.Item>

        {/* Size */}
        <Accordion.Item value="size">
          <Accordion.ItemTrigger>
            {sectionTitle("Size", activeFlags.sizes)}
          </Accordion.ItemTrigger>
          <Accordion.ItemContent>
            <Accordion.ItemBody>
              <MotionBox {...contentAnim}>
                <SizeSelect
                  selectedValue={filters.sizes}
                  sizeItems={sizesData}
                  onChange={(size) => handleFilterChange("sizes", size)}
                />
              </MotionBox>
            </Accordion.ItemBody>
          </Accordion.ItemContent>
        </Accordion.Item>

        {/* Price */}
        <Accordion.Item value="price">
          <Accordion.ItemTrigger>
            {sectionTitle("Price", activeFlags.price)}
          </Accordion.ItemTrigger>
          <Accordion.ItemContent>
            <Accordion.ItemBody>
              <MotionBox {...contentAnim}>
                <Slider.Root
                  min={0}
                  max={5000}
                  defaultValue={[filters.min_price, filters.max_price]}
                  onValueChangeEnd={(e) => handleFilterChange("price", e.value)}
                  width="full"
                >
                  <Slider.Control>
                    <Slider.Track>
                      <Slider.Range bg="tomato" />
                    </Slider.Track>
                    <Slider.Thumb index={0}>
                      <Box as={MdGraphicEq} color="tomato" />
                    </Slider.Thumb>
                    <Slider.Thumb index={1}>
                      <Box as={MdGraphicEq} color="tomato" />
                    </Slider.Thumb>
                  </Slider.Control>
                </Slider.Root>
                <Text mt={2} fontSize="xs" color="gray.600">
                  ₹ {filters.min_price} – ₹ {filters.max_price}
                </Text>
              </MotionBox>
            </Accordion.ItemBody>
          </Accordion.ItemContent>
        </Accordion.Item>

        {/* Sort */}
        <Accordion.Item value="sort">
          <Accordion.ItemTrigger>
            {sectionTitle("Sort By", activeFlags.sort)}
          </Accordion.ItemTrigger>
          <Accordion.ItemContent>
            <Accordion.ItemBody>
              <MotionBox {...contentAnim}>
               <SelectC
  items={sortOptions}
  placeholder={sortBy ? sortBy.label : "Select Sort By"}
  size="xs"
  selectedValue={sortBy ? sortBy.label : null}
  onValueChange={(val) => {
    console.log(val)
    handleFilterChange("sort_by", val.value[0]);
    setSortBy(val.items[0]);
  }}
/>

              </MotionBox>
            </Accordion.ItemBody>
          </Accordion.ItemContent>
        </Accordion.Item>

        {/* Actions */}
        {/* <Accordion.Item value="actions">
          <Accordion.ItemTrigger>
            <Flex w="full" align="center" justify="space-between">
              <Text fontWeight="semibold">Actions</Text>
              <Accordion.ItemIndicator />
            </Flex>
          </Accordion.ItemTrigger>
          <Accordion.ItemContent>
            <Accordion.ItemBody>
              <MotionBox {...contentAnim}>
                <VStack spacing={4} align="stretch" mt={2}>
                  <HStack justify="space-between">
                    <Tooltip content="Previous Filter">
                      <IconButton
                        size="xs"
                        variant="outline"
                        aria-label="Prev"
                      >
                        <FiArrowLeft />
                      </IconButton>
                    </Tooltip>
                    <Tooltip content="Next Filter">
                      <IconButton
                        size="xs"
                        variant="outline"
                        aria-label="Next"
                      >
                        <FiArrowRight />
                      </IconButton>
                    </Tooltip>
                  </HStack>

                  <Separator />

                  <HStack justify="space-between">
                    <Tooltip content="Refresh">
                      <IconButton
                        size="xs"
                        variant="outline"
                        onClick={refresh}
                        aria-label="Refresh"
                      >
                        <FiRotateCw />
                      </IconButton>
                    </Tooltip>
                    <Tooltip content="Clear All Filters">
                      <IconButton
                        size="xs"
                        variant="outline"
                        onClick={clear}
                        aria-label="Clear"
                      >
                        <FiX />
                      </IconButton>
                    </Tooltip>
                  </HStack>
                </VStack>
              </MotionBox>
            </Accordion.ItemBody>
          </Accordion.ItemContent>
        </Accordion.Item> */}
      </Accordion.Root>
    </Box>
  );
}
